import styled from 'styled-components';

export const Title = styled.h1`
	margin: 10px 0;
	text-align: center;
`;

export const GalleryContainer = styled.div`
	display: flex;
	flex-direction: column;
`;

export const CurrentContainer = styled.div`
	margin: 10px;
`;

export const CurrentImg = styled.img`
	width: 80%;
	height: auto;
	border-radius: 10px;
	display: block;
	margin: 0 auto;
`;

export const PreviewContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	margin: 10px 0;
	width: 100%;
	overflow-x: auto;
`;

export const PreviewImg = styled.img`
	cursor: pointer;
	width: 10%;
	height: auto;
	margin: 0 2%;
	border-radius: 10px;
`;
